import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { permissionApi } from "./api";
import type { PermissionResponse } from "./types";

export function usePermissions(search?: string) {
  return useQuery<PermissionResponse[], Error>({
    queryKey: ["permissions", search ?? ""],
    queryFn: () => permissionApi.list(search),
    staleTime: 1000 * 60 * 2,
    // Keep showing the previous page's results (and the search input stays mounted
    // and focused) while a new search term's request is in flight, instead of the
    // whole list — and the search box along with it — unmounting into a full-page
    // loader on every keystroke. See PermissionPage.tsx for the matching debounce.
    placeholderData: keepPreviousData,
  });
}

export function useTogglePermission() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, active }: { id: number; active: boolean }) =>
      active ? permissionApi.activate(id) : permissionApi.deactivate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["permissions"] }),
  });
}
